<template>
  <div class="login-out">
    <div class="out-content">
      <el-row>
        <el-col v-html="imgUrl"></el-col>
        <el-col><span class="tips_text">{{message}}</span></el-col>
        <el-col class="return_page" v-if="$route.params.status==2">
          <el-button type="primary" @click="goBack">返回欢迎页</el-button>
    
        </el-col>
      </el-row>
       
    </div>
  </div>
</template>
<script>
import login from "@/services/login/login";
export default {
  name:'login-out',
  data(){
    return{
      imgUrl:"",
      message:""
    }
  },
 watch: {
  $route: {
    handler: function(val){
      switch (val.params.status) {
        case '1'://没有权限没有权限
          this.imgUrl="<img src='../../../static/image/1.png'>"
          this.message="未授权"
        break;
        case '2'://连接超时
         this.imgUrl="<img src='../../../static/image/1.png'>"
         this.message="抱歉，您没有权限"
        break;
        case '3'://退出登录
        this.imgUrl="<img src='../../../static/image/4.png'>"
         this.message="退出成功"
        break
      
      }
    },
    immediate: true
  }
},
  methods:{
    async loginOut(){
      if(this.$route.params.status!=2){
        try{
          let result=await login.loginOut({token:localStorage.getItem("Authorization")})
        }catch(err){
          
        }
        setTimeout(() => {
         localStorage.removeItem("Authorization")
         localStorage.removeItem("name")
          this.$router.push("/")
        }, 1800);
      }
    },
    goBack(){
      this.$router.push("/choseWeb")
    }
  },
  mounted(){
      this.loginOut()
  }
}
</script>
<style lang="scss">
  .login-out{
    height:100%;
    background: url("../../../static/image/bg.png") no-repeat;
    background-size: cover;
    .out-content{
      width:100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      .el-row{
        width:inherit;
        text-align: center;       
      }
      .return_page{
        margin-top:40px;
      }
      .tips_text{
        margin-top:20px;
        font-size: 20px;
        display: inline-block;
        color: #4e5058;
      }
      i{
        font-size: 103px;
        color: #36c626;
      }
    }
  }
</style>





// WEBPACK FOOTER //
// src/pages/loginOut/out.vue